module.exports = "/static/assets/5f12e8bceba4f21180c7e49a028281ef.png";